// src/components/KiddoSmiley/KiddoSmiley.tsx
import React, { FC } from 'react';
import classes from './KiddoSmiley.module.less';

// Na ekranie jest naraz najwyżej jedna buźka, więc gradient może mieć stałe id
const GRADIENT_ID = 'kiddoSmileyGradient';

// Buźka po dobrej odpowiedzi w grach Easy (Ułóż słowa, Napisz, Literuj) zamiast kciuka. Z tego samego materiału
// co gwiazdki na zakończeniu (KiddoStars): pomarańczowy gradient, ciemniejszy brzeg, odblask i ta sama buźka,
// tylko w kółku. Wielkość, kolory i to, jak wyskakuje i mruga, ustala styl
const KiddoSmiley: FC = () => (
  <svg className={classes.smiley} viewBox="0 0 24 24" aria-hidden>
    <defs>
      <linearGradient id={GRADIENT_ID} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" className={classes.gradientTop} />
        <stop offset="1" className={classes.gradientBottom} />
      </linearGradient>
    </defs>
    <circle className={classes.body} cx="12" cy="12" r="9.6" fill={`url(#${GRADIENT_ID})`} />
    <ellipse className={classes.shine} cx="7.6" cy="7.4" rx="0.8" ry="1.9" transform="rotate(42 7.6 7.4)" />
    <g className={classes.eyes}>
      <ellipse cx="9" cy="10.4" rx="1.05" ry="1.45" />
      <ellipse cx="15" cy="10.4" rx="1.05" ry="1.45" />
      <circle className={classes.eyeShine} cx="9.35" cy="9.85" r="0.4" />
      <circle className={classes.eyeShine} cx="15.35" cy="9.85" r="0.4" />
    </g>
    <path className={classes.smile} d="M8.7 13.7Q12 17.2 15.3 13.7" />
    <ellipse className={classes.cheek} cx="6.8" cy="13.6" rx="1.25" ry="0.75" />
    <ellipse className={classes.cheek} cx="17.2" cy="13.6" rx="1.25" ry="0.75" />
  </svg>
);

export default KiddoSmiley;
